import { PropsWithChildren, ReactNode } from 'react';

import * as S from './styles';

type AppShellProps = PropsWithChildren<{
  header?: ReactNode;
  sidebar?: ReactNode;
}>;

export const AppShell = ({ children, header, sidebar }: AppShellProps) => (
  <S.AppShellContainer>
    {header}
    <S.AppShellBody>
      {sidebar}
      <S.MainContent>
        <S.PageContent>{children}</S.PageContent>
      </S.MainContent>
    </S.AppShellBody>
  </S.AppShellContainer>
);

export default AppShell;
